// frontend/src/components/Footer/Footer.js
import React, { useState, useEffect, useRef } from "react";
import { Nav, Container, Button, Dropdown } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Footer.css";
import usFlag from "../../images/flags/us.png";  // You'll need to add these images
import noFlag from "../../images/flags/no.png";
import mmFlag from "../../images/flags/mm.png";
import { useTranslation } from "react-i18next";
import { useUserAuth } from "../../context/UserAuthContext";

const Footer = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const { user } = useUserAuth();

    const [visible, setVisible] = useState(true);
    const [scrolled, setScrolled] = useState(false);
    const lastScrollY = useRef(0);
    const footerRef = useRef(null);

    // Check if we're on the homepage
    const isHomepage = location.pathname === '/' || location.pathname === '';

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setScrolled(currentScrollY > 50);

            if (currentScrollY < 50) {
                setVisible(true);
                return;
            }

            if (currentScrollY > lastScrollY.current) {
                setVisible(false);
            } else {
                setVisible(true);
            }

            lastScrollY.current = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleLanguageChange = (language) => {
        i18n.changeLanguage(language);
    };
    
    // handleLogout moved to header component

    return (
        <footer
            className={`main-footer ${!visible ? "footer-hidden" : ""} ${scrolled ? "scrolled" : ""} ${isHomepage ? "homepage-footer" : ""}`}
            ref={footerRef}
        >
            <Container fluid className="footer-container">
                <div className="footer-content">
                    <div className="language-buttons">
                        <button
                            className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
                            onClick={() => handleLanguageChange("en")}
                        >
                            <img src={usFlag} alt="US Flag" className="flag-icon" />
                            <span className="lang-text">{t("footer.english")}</span>
                        </button>
                        <button
                            className={`lang-btn ${i18n.language === 'no' ? 'active' : ''}`}
                            onClick={() => handleLanguageChange("no")}
                        >
                            <img src={noFlag} alt="Norwegian Flag" className="flag-icon" />
                            <span className="lang-text">{t("footer.norwegian")}</span>
                        </button>
                        <button
                            className={`lang-btn ${i18n.language === 'my' ? 'active' : ''}`}
                            onClick={() => handleLanguageChange("my")}
                        >
                            <img src={mmFlag} alt="Myanmar Flag" className="flag-icon" />
                            <span className="lang-text">{t("footer.myanmar")}</span>
                        </button>
                        <button
                            className={`lang-btn ${i18n.language === 'zo' ? 'active' : ''}`}
                            onClick={() => handleLanguageChange("zo")}
                        >
                            <img src={mmFlag} alt="Zopau Flag" className="flag-icon" />
                            <span className="lang-text">{t("footer.zopau")}</span>
                        </button>
                    </div>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;